import React, { createContext, useContext, useState } from "react";

// Clave nueva a propósito: antes la ayuda venía encendida y así todos arrancan con ella oculta.
const CLAVE_AYUDA = "ayudaVisible";

const AyudaContext = createContext({ mostrarAyuda: false, alternarAyuda: () => {} });

// Controla, para toda la app, si se muestran los textos explicativos
// (subtítulos de página, notas de "cómo funciona esto") — algunos usuarios
// ya conocen el sistema y prefieren una pantalla más limpia. Viene oculta y cada
// usuario la enciende con el botón de arriba. Se guarda en localStorage para que
// la preferencia persista entre sesiones.
export function AyudaProvider({ children }) {
  const [mostrarAyuda, setMostrarAyuda] = useState(() => {
    try {
      return localStorage.getItem(CLAVE_AYUDA) === "true";
    } catch {
      return false;
    }
  });

  const alternarAyuda = () => {
    setMostrarAyuda((v) => {
      const nuevo = !v;
      try {
        localStorage.setItem(CLAVE_AYUDA, String(nuevo));
      } catch {
        // localStorage no disponible (modo privado, etc.) — la preferencia
        // simplemente no persiste entre sesiones, no es un error fatal.
      }
      return nuevo;
    });
  };

  return (
    <AyudaContext.Provider value={{ mostrarAyuda, alternarAyuda }}>{children}</AyudaContext.Provider>
  );
}

export function useAyuda() {
  return useContext(AyudaContext);
}

// Envuelve cualquier texto/bloque explicativo — se oculta por completo
// cuando el usuario apagó la ayuda, sin que cada pantalla tenga que
// repetir la lógica del if.
export function Ayuda({ children }) {
  const { mostrarAyuda } = useAyuda();
  return mostrarAyuda ? children : null;
}
